import type { MenuConfig } from '~typings/menu'

import permisosTributacionPg, { RESOURCE_TRIBUTACION_PG } from '@/auth/permissions/modules/tributacionPg'
import * as names from '@routes/tributacion-pg/nombres/mantenimiento'

const { mantenimiento } = permisosTributacionPg
export default [
    {
        title: 'tributacion.subopciones.retencion_iva',
        route: names.ROUTE_RETENCION_IVA,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.retencionIVA,
    },
    {
        title: 'tributacion.subopciones.politica_iva',
        route: names.ROUTE_POLITICA_IVA,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.politicaIVA,
    },
    {
        title: 'tributacion.subopciones.sustento_comprobante',
        route: names.ROUTE_SUSTENTO_TRIBUTARIO,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.sustentoTributario,
    },
    {
        title: 'tributacion.subopciones.codigo_formulario_104',
        route: names.ROUTE_CODIGO_FORMULARIO_104,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.codigoFormulario104,
    },
    {
        title: 'tributacion.subopciones.paises',
        route: names.ROUTE_PAISES,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.paises,
    },
    {
        title: 'tributacion.subopciones.provincias',
        route: names.ROUTE_PROVINCIAS,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.provincias,
    },
    {
        title: 'tributacion.subopciones.ciudades',
        route: names.ROUTE_CIUDADES,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.ciudades,
    },
    {
        title: 'tributacion.subopciones.punto_emision',
        route: names.ROUTE_PUNTO_EMISION,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.puntoEmision,
    },
    {
        title: 'tributacion.subopciones.distrito_aduanero',
        route: names.ROUTE_DISTRITO_ADUANERO,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.distritoAduanero,
    },
    {
        title: 'tributacion.subopciones.fideicomiso',
        route: names.ROUTE_FIDEICOMISO,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.fideicomiso,
    },
    {
        title: 'tributacion.subopciones.forma_pago_cobro',
        route: names.ROUTE_FORMA_PAGO_COBRO,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.formaPagoCobro,
    },
    {
        title: 'tributacion.subopciones.exportaciones',
        route: names.ROUTE_EXPORTACIONES,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.exportaciones,
    },
    {
        title: 'tributacion.subopciones.comprobante',
        route: names.ROUTE_COMPROBANTE,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.comprobante,
    },
    {
        title: 'tributacion.subopciones.regimen_fiscal',
        route: names.ROUTE_REGIMEN_FISCAL,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.regimenFiscal,
    },
    {
        title: 'tributacion.subopciones.tipo_contribuyente',
        route: names.ROUTE_TIPO_CONTRIBUYENTE,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.tipoContribuyente,
    },
    {
        title: 'tributacion.subopciones.gestion_partidas_arancelarias',
        route: names.ROUTE_GESTION_PARTIDAS_ARANCELARIAS,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.gestionPartidasArancelarias,
    },
    {
        title: 'tributacion.subopciones.paraiso_fiscal',
        route: names.ROUTE_PARAISO_FISCAL,
        resource: RESOURCE_TRIBUTACION_PG,
        action: mantenimiento.paraisoFiscal,
    },
] as MenuConfig[]
